import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-origin-upload-field',
  templateUrl: './origin-upload-field.component.html',
  styleUrls: ['./origin-upload-field.component.scss']
})
export class OriginUploadFieldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
